/**
 *
 * App
 */

import LoadingScreen from 'components/LoadingScreen'
import { ConfirmPage } from 'containers/auth/ConfirmPage'
import { SignoutPage } from 'containers/auth/SignoutPage'
import { AdminLayout } from 'containers/layout/AdminLayout'
import { ResourceProvider } from 'contexts'
import { AppProvider } from 'contexts/AppContext'
import { SessionContext, SessionProvider } from 'contexts/SessionContext'
import dayjs from 'dayjs'
import 'dayjs/locale/id'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import React, { PropsWithChildren, useContext } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import { GlobalStyle } from 'styles/global-styles'
import { ThemeProvider } from 'styles/theme/ThemeProvider'
import { LoginPage } from './containers/auth/LoginPage'
dayjs.extend(localizedFormat)
dayjs.locale('id')

export default function App(): JSX.Element {
  return (
    <ThemeProvider>
      <HelmetProvider>
        <SessionProvider>
          <ResourceProvider>
            <AppProvider>
              <React.Suspense fallback={<LoadingScreen />}>
                <BrowserRouter>
                  <Helmet titleTemplate="%s - App" defaultTitle="Multi assets">
                    <meta name="description" content="App platform remittance by 5Elements" />
                  </Helmet>
                  <Switch>
                    <Route path="/" exact={true} render={() => <InitialRoute />} />
                    <Route path="/auth">
                      <Route path="/auth/signin" component={LoginPage} />
                      <Route path="/auth/signout" component={SignoutPage} />
                      <Route path="/auth/confirm" component={ConfirmPage} />
                    </Route>
                    <PrivateRoute>
                      <Route path={'/admin'} component={AdminLayout}></Route>
                    </PrivateRoute>
                  </Switch>
                  <GlobalStyle />
                </BrowserRouter>
              </React.Suspense>
            </AppProvider>
          </ResourceProvider>
        </SessionProvider>
      </HelmetProvider>
    </ThemeProvider>
  )
}

const PrivateRoute: React.FC<{ children: PropsWithChildren<any> }> = ({ children }) => {
  const [session] = useContext(SessionContext)
  if (session.loading) {
    return <LoadingScreen />
  }
  const isLoggedIn = session.user ? true : false

  return isLoggedIn ? children : <Redirect to="/auth/signin" />
}

const InitialRoute: React.FC = () => {
  const [session] = useContext(SessionContext)
  if (session.loading) {
    return <LoadingScreen />
  }
  const isLoggedIn = session.user ? true : false
  return isLoggedIn ? <Redirect to="/admin/dashboard" /> : <Redirect to="/auth/signin" />
}
